import tracking from 'dibs-tracking';

export default {
    trackClose: () => {
        tracking.trackEvent({
            category: 'product',
            action: 'deposits details',
            label: 'deposits details closed',
            value: '0',
        });
    },
};
